import { AbstractValidator } from "./AbstractValidator";
import { IValidator } from "./IValidator";
import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";

import { Yii } from "libraries/interfaces/Yii";

export class Email extends AbstractValidator implements IValidator {
    public static readonly NAME: string = 'email';

    public constructor() {
        super({
            [Email.NAME]: {
                when: 'touched',
                message: Yii.t('wui-shared-js', 'Vous devez saisir une adresse email valide'),
            },
        });
    }

    public validate(control: AbstractControl): ValidationErrors | null {
        return Validators.email(control);
    }
}